import { useCallback, type PointerEvent as ReactPointerEvent } from "react";

/**
 * Makes a `.backlit` element's halo follow the pointer by writing --mx/--my.
 * Spread the returned handler: `<div className="backlit" onPointerMove={glow}>`.
 */
export function useGlowPointer() {
  return useCallback((event: ReactPointerEvent<HTMLElement>) => {
    const el = event.currentTarget;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${event.clientX - rect.left}px`);
    el.style.setProperty("--my", `${event.clientY - rect.top}px`);
  }, []);
}
